import { CanLeavePageGuard } from './guards/can-leave-page.guard';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { EnumPageStates } from '@pages/error/error.page';
import { MaintenanceGuard } from '@guards/maintenance.guard';

const routes: Routes =
    [
        {
            path: '',
            redirectTo: `/dashboard`,
            pathMatch: 'full'
        },
        {
            path: 'login',
            loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
        },
        {
            path: 'initialize',
            loadChildren: () => import('./pages/initialize/initialize.module').then(m => m.InitializePageModule)
        },
        {
            path: 'dashboard',
            canActivate: [AuthGuard, MaintenanceGuard],
            loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule)
        },
        {
            path: 'news',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/news/news.module').then(m => m.NewsModule)
        },
        {
            path: 'content',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/content/content.module').then(m => m.ContentModule)
        },
        {
            path: 'settings',
            canActivate: [AuthGuard, MaintenanceGuard],
            loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule)
        },
        {
            path: 'support',
            canActivate: [AuthGuard, MaintenanceGuard],
            loadChildren: () => import('./pages/support/support.module').then(m => m.SupportPageModule)
        },
        {
            path: 'configurations',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/configurations/configurations.module').then(m => m.ConfigurationsPageModule)
        },
        {
            path: 'users',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/users/users.module').then(m => m.UsersPageModule)
        },
        {
            path: 'account',
            canActivate: [AuthGuard, MaintenanceGuard],
            loadChildren: () => import('./pages/account/account.module').then(m => m.AccountPageModule),
        },
        {
            path: 'notifications',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsPageModule)
        },
        {
            path: 'campaigns',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/campaigns/campaigns.module').then(m => m.CampaignsPageModule)
        },
        // Deprecated
        // {
        //     path: 'benefits',
        //     canActivate: [AuthGuard,MaintenanceGuard],
        //     canActivateChild: [AuthGuard,MaintenanceGuard],
        //     loadChildren: () => import('./pages/campaigns/benefits/benefits.module').then(m => m.BenefitsPageModule)
        // },
        // {
        //     path: 'invoice-benefits',
        //     canActivate: [AuthGuard,MaintenanceGuard],
        //     canActivateChild: [AuthGuard,MaintenanceGuard],
        //     loadChildren: () => import('./pages/campaigns/invoice-benefits/invoice-benefits.module').then(m => m.InvoiceBenefitsPageModule)
        // },
        {
            path: 'categories',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/categories/categories.module').then(m => m.CategoriesPageModule)
        },
        {
            path: 'consumers',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/consumers/consumers.module').then(m => m.ConsumersPageModule)
        },
        {
            path: 'consumers-wallet',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/consumers/consumers.module').then(m => m.ConsumersPageModule)
        },
        {
            path: 'merchants',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/merchants/merchants.module').then(m => m.MerchantsPageModule)
        },
        {
            path: 'financial',
            canActivate: [AuthGuard, MaintenanceGuard],
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/financial/financial.module').then(m => m.FinancialPageModule)
        },
        {
            path: 'recovery',
            canActivate: [MaintenanceGuard],
            loadChildren: () => import('./pages/recovery-password/recovery-password.module').then(m => m.RecoveryPasswordPageModule)
        },
        {
            path: 'maintenance',
            loadChildren: () => import('./pages/maintenance/maintenance.module').then(m => m.MaintenancePageModule)
        },

        {
            path: 'error',
            loadChildren: () => import('./pages/error/error.module').then(m => m.ErrorPageModule)
        },

        {
            path: '**',
            redirectTo: `/error?id=${EnumPageStates.NOTFOUND}`
        },




    ];


@NgModule(
    {
        imports:
            [
                RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
            ],
        providers: [CanLeavePageGuard],
        exports: [RouterModule]
    })
export class AppRoutingModule { }